<template>
  <div>
    <div class="sticky-area" v-if="device === 'mobile'">
      <common-header :title="headerTitle" :is-close-btn="true" :close-fn="close"></common-header>
    </div>
    <div v-if="$route.name === 'voucher_promotion'" :class="'voucher-view-oksusu' + (device !== 'mobile' ? ' not-mobile' : '')">
      <router-view name="voucher_promotion" key="voucher_promotion"></router-view>
    </div>
    <div v-else :class="'voucher-view' + (device !== 'mobile' ? ' not-mobile' : '')">
      <router-view name="index" key="index"></router-view>
      <router-view name="regist" key="regist"></router-view>
      <router-view name="pooqzone" key="pooqzone"></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MY_POOQ_VOUCHER_MENU_LIST } from '@/common/menu.constant'
import utils from '@/common/util/utils'
import CommonHeader from '@/components/header/template/commonHeader'
import { get } from 'lodash'
import { PATH_NAME_VOUCHER_INDEX, PATH_NAME_WAVVEON } from '@/common/router.const'
export default {
  name: 'Voucher',
  components: {
    CommonHeader
  },
  data () {
    return {
      routeMenu: '',
      menuItems: MY_POOQ_VOUCHER_MENU_LIST,
      mainMenuIndex: 0,
      device: utils.cookies.getDevice()
    }
  },
  created () {
    const lastPath = get(this.$route, 'path', '').split('/').pop().replace('.html', '')
    if (lastPath === 'voucher' || this.$route.path === '/voucher/') {
      this.$router.replace({ name: PATH_NAME_VOUCHER_INDEX })
    }
    switch (lastPath) {
      case 'index':
        this.mainMenuIndex = 0
        break
      case 'regist':
        this.mainMenuIndex = 1
        break
      case 'wavveon':
      case 'pooqzone':
        this.mainMenuIndex = 2
        break
    }
  },
  computed: {
    ...mapGetters(['getBeforePathOpenMyPooq']),
    headerTitle () {
      return get(this.$route, 'name', '') === PATH_NAME_WAVVEON ? '웨이브온 이용권' : '이용권'
    }
  },
  methods: {
    changeMainMenu (mainMenuObject) {
      this.mainMenuIndex = mainMenuObject.index
      this.$router.push(mainMenuObject.path)
    },
    close () {
      this.$router.replace(this.getBeforePathOpenMyPooq)
    }
  },
  beforeUpdate () {
    const lastPath = this.$route.path.split('/').pop()
    let menuItem = this.menuItems.filter((menu) => {
      return menu.value === lastPath
    })
    if (menuItem.length > 0 && this.mainMenuIndex !== menuItem[0].index) {
      this.mainMenuIndex = menuItem[0].index
    }
  }
}
</script>

<style lang="css" scoped>
  .voucher-view {
    height: 100vh;
  }
  .voucher-view.not-mobile {
    padding-top: 0;
  }
  .voucher-view.not-mobile,
  .voucher-view-oksusu.not-mobile{
    padding-top: 0;
  }
</style>
